export default "__VITE_ASSET__08d0dde8__"